<template>
  <a-drawer
    title="商品初始化11"
    :width="1500"
    :visible="visible"
    :footer="null"
    @close="handleClose"
  >
    <a-spin :spinning="loading">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left" :model="form"
                    :rules="rules">
        <a-collapse v-model="activeKey">
          <a-collapse-panel key="1" :header="$t('商品.基础信息')" class="goods-collapse">
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }" :label="$t('商品.商品名称')" prop="goodsName">
                  <a-input v-model="form.goodsName" :maxLength="128" :placeholder="$t('通用.输入.请输入')+$t('商品.商品名称')"/>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.商品分类')" prop="categoryId" v-if="form.goodsType===1">
                  <template>
                    <a-cascader :options="categoryListPlat"
                                :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                                :placeholder="$t('通用.输入.请输入')+$t('商品.商品分类')"
                                style="width: 100%" v-model="categorySelected" allowClear @change="onCategoryChange">
                    </a-cascader>
                  </template>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="this.$t('商品.商品主图')" prop="picture">
                  <OssUploadSingle v-model="form.picture" type="img" :maxSize="200"></OssUploadSingle>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.商品轮播图')" prop="imgList">
                  <OssUploadMulti v-model="form.imgList" :isArrayData="true" :max-count="5" :prefix="goods" type="img" :draggable="true"></OssUploadMulti>
                  <div class="color-gray" style="font-size: 12px; margin-top: 4px;">拖动图片可调整轮播顺序</div>
                </a-form-model-item>
<!--                <a-form-model-item :label="$t('商品.商品轮播图')" prop="imgList">-->
<!--                  <OssUploadMulti v-model="form.imgList" :isArrayData="true" :max-count="5" :prefix="goods" type="img"></OssUploadMulti>-->
<!--                </a-form-model-item>-->
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="this.$t('商品.商品视频')" prop="video" v-if="form.goodsType===1">
                  <OssUploadSingle v-model="form.video" type="video" :prefix="goods" :maxSize="200"></OssUploadSingle>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item :label="$t('商品.品牌')" prop="brandId" v-if="form.goodsType===1">
                  <a-select style="width: 100%" v-model="form.brandId" placeholder="请选择品牌"
                            allowClear
                            :filter-option="false" :show-arrow="false" :not-found-content="null"
                            :default-active-first-option="false"
                            show-search
                            @search="handleBrandSearch"
                            @change="handleBrandChange">
                    <a-select-option v-for="(item, index) in brandList" :value="item.id" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel key="3" :header="$t('商品.规格信息')" class="goods-collapse">
            <a-row>
              <a-col :span="12">
                <a-form-model-item class="margin-bottom-10" :label="$t('商品.是否多规格')" prop="isMultipleSpec"
                                   v-if="form.goodsType===1">
                  <a-radio-group button-style="solid" v-model="form.isMultipleSpec"
                                 @change="multipleSpecChange()">
                    <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>

            <!-- 多规格配置 -->
            <a-row>
              <div v-if="!form.isMultipleSpec">
                <a-col :span="12">
                  <a-form-model-item :label="$t('商品.商品重量')" prop="weight"
                                     v-if="form.goodsType===1 && !form.isMultipleSpec">
                    <a-input v-model="form.weight" @change="limitWeight()" suffix="g"
                             :placeholder="$t('通用.输入.请输入')+$t('商品.商品重量')"/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="商品条码" prop="barcode"
                                     v-if="form.goodsType===1 && !form.isMultipleSpec">
                    <a-input v-model="form.barcode" :placeholder="'请输入商品条码'"/>
                  </a-form-model-item>
                </a-col>
              </div>
            </a-row>
            <a-row>
              <a-col span="2" v-if="form.isMultipleSpec  && form.goodsType===1">
                <a-button v-if="form.specList.length < 4" :disabled="specDisable" type="primary" style="width: 100%"
                          @click="addSpec(1)"
                          class="margin-bottom">
                  <a-icon type="plus"/>
                  {{ $t('商品.添加规格') }}
                </a-button>
              </a-col>
              <a-col span="2" v-if="specDisable && form.isMultipleSpec && form.goodsType===1">
                <a-button v-if="form.specList.length < 4" :disabled="!specDisable" type="primary" style="width: 100%"
                          @click="editSpec()"
                          class="margin-bottom">
                  <a-icon type="edit"/>
                  {{ $t('商品.修改规格') }}
                </a-button>
              </a-col>
              <a-col :span="20">
              </a-col>
            </a-row>
            <div v-if="form.isMultipleSpec && form.goodsType===1">
              <div class="box" v-for="(item, id) in form.specList" :key="id">
                <a-row>
                  <a-popconfirm title="确定要删除此规格吗?" ok-text="确定" cancel-text="取消" @confirm="delSpec(id)">
                    <a-icon type="close-circle" class="delSpec"/>
                  </a-popconfirm>
                  <a-col :span="18">
                    <a-form-model-item layout="inline" :label="$t('商品.规格.规格名称')" :prop="`specList.${id}.specName`"
                                       :rules='rules.specName'>
                      <a-input v-model="item.specName" :placeholder="$t('通用.输入.请输入')"/>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="18">
                    <a-form-model-item layout="inline" :label="$t('商品.规格.是否有规格图片')" v-show="!isSpecPic||item.isHaveImg">
                      <a-radio-group button-style="solid" v-model="item.isHaveImg" @change="isSpecPicChange"
                                     :disabled="specDisable">
                        <a-radio-button v-for="(visibleItem, v_index) in customDict.TFEnum" :value="visibleItem.type"
                                        :key="v_index">
                          {{ visibleItem.name }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row>
                  <a-col :span="20" :offset="2">
                    <div class="margin-bottom-10">
                      <a-button type="primary" @click='addSpecValue(item)' :disabled="specDisable">
                        {{ $t('商品.规格.添加规格值') }}
                      </a-button>
                    </div>
                    <a-table :data-source="item.specValueList" :columns="specValueColumns" rowKey="id"
                             :pagination="false"
                             bordered>
                      <div slot="specValueName" slot-scope="text, record">
                        <a-input :disabled="specDisable" v-model="record.specValueName" :maxLength="32"
                                 placeholder="请输入规格" @blur="validatorSpecValue(item)"/>
                      </div>
                      <div slot="isValueVisible" slot-scope="text, record">
                        <a-radio-group button-style="solid" v-model="record.isVisible"
                                       :disabled="getLimitOne(record.index,item.specValueList)">
                          <a-radio-button v-for="(visibleVauleItem, v_i_index) in customDict.TFEnum"
                                          :value="visibleVauleItem.type"
                                          :key="v_i_index">
                            {{ visibleVauleItem.name }}
                          </a-radio-button>
                        </a-radio-group>
                      </div>
                      <div v-show="item.isHaveImg" slot="valuePicture" slot-scope="text, record">
                        <a-upload :disabled="specDisable"
                                  name="valuePicture"
                                  listType="picture-card"
                                  :multiple="false"
                                  :show-upload-list="false"
                                  :preview="handlePreview"
                                  :before-upload="beforeOssUpload"
                                  :customRequest="e=>coverSpecValueImgUpload(e,record)">
                          <img
                            v-if="record.picture"
                            :src="record.picture"
                            alt="picture"
                            style="height: 102px; width: 102px;"/>
                          <div v-else>
                            <a-icon :type="loading ? 'loading' : 'plus'"/>
                            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
                          </div>
                        </a-upload>
                      </div>
                      <div slot="action" slot-scope="text, record">
                        <a-popconfirm title="确定要删除此规格值吗？" ok-text="确定" cancel-text="取消" v-if="!specDisable"
                                      @confirm="delSpecValue(item,record)">
                          <a href="javascript:void(0)" style="color:red;">删除</a>
                        </a-popconfirm>
                      </div>
                    </a-table>
                    <span style="color: red;" v-if="item.specErrorMessage">{{ item.specErrorMessage }}</span>
                  </a-col>
                </a-row>
              </div>
              <!-- SKU列表(不包含价格和库存) -->
              <div>
                <a-row>
                  <a-col :span="20" :offset="2">
                    <a-button class='margin-tb' type="primary" @click="generateSkus" :disabled="specDisable">生成sku
                    </a-button>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="20" :offset="2">
                    <a-table :loading="skuLoading" :data-source="form.skuList" :columns="skuColumns" rowKey="id"
                             :pagination="false" bordered>
<!--                      <div slot="skuCode" slot-scope="text, record">-->
<!--                        <a-input v-model="record.skuCode" :placeholder="$t('通用.输入.请输入')+$t('商品.SKU编码')"-->
<!--                                 @blur.native.capture="validatorSku"/>-->
<!--                      </div>-->
                      <div slot="barcode" slot-scope="text, record">
                        <a-input v-model="record.barcode" :placeholder="'请输入商品条码'"/>
                      </div>
                      <div slot="skuWeight" slot-scope="text, record">
                        <a-input v-model="record.weight" :placeholder="$t('通用.输入.请输入')+$t('商品重量（g）')"
                                 @blur.native.capture="validatorSku"/>
                      </div>
                      <template slot="skuPicture" slot-scope="text, record">
                        <div>
                          <img v-if="record.picture" :src="record.picture" style="width:60px;height:62px;" alt="none"/>
                        </div>
                      </template>
                    </a-table>
                    <span style="color: red;" v-if="skuErrorMessage">{{ skuErrorMessage }}</span>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-collapse-panel>
          <a-collapse-panel key="4" :header="$t('商品.商品详情')" class="goods-collapse" v-if="form.goodsType===1">
            <a-row style="height: 30px">
              <a-col></a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}" :label="$t('商品.商品详情')"
                                   prop="description">
                  <editor v-model="form.description" :placeholder="$t('通用.输入.请输入')+$t('商品.商品详情')"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <!-- 按钮组 -->
        <div style="margin-top: 20px; text-align: right;">
          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="margin-left: 8px;">
            保存
          </a-button>
        </div>
      </a-form-model>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl"/>
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      </a-spin>
    </a-drawer>
</template>

<script>
import {allBrand, listBrand} from '@/api/goods/brand'
import {addGoods} from '@/api/goods/goods'
import {listCategoryPlat,listCategoryShop} from "@/api/goods/category";
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {uploadObject, uploadOss} from "@/api/tool/oss";
import Editor from '@/components/Editor'
import OssUploadSingle from "@/components/OssUploadSingle";
import OssUploadMulti from "@/components/OssUploadMulti";
import storage from 'store'
import {SHOP_ID} from "@/store/mutation-types";

export default {
  name: 'InitDrawer',
  components: {
    Editor,
    CustomDictTag,
    OssUploadSingle,
    OssUploadMulti,
  },
  data() {
    return {
      tabIndex: 1,
      visible: false,
      loading: false,
      submitLoading: false,
      categoryListPlat: [{id: "0", categoryName: '', children: []}],
      categoryListShop: [{id: "0", categoryName: '', children: []}],
      crossCategoryList: [{id: "0", categoryName: '', children: []}],
      brandList: [],
      packageIdList: [],
      labelList: [],
      isSpecPic: false,
      categorySelected: [],
      categorySelectedShop: [],
      crossCategorySelected: [],
      labelCol: {span: 4},
      activeKey: [1, 2, 3, 4],
      wrapperCol: {span: 16},
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      skuLoading: false,
      imgList: [],
      skuErrorMessage: undefined,
      errorMessage: undefined,
      specValueColumns: [
        {
          title: this.$t('商品.规格.规格值'),
          dataIndex: 'specValueName',
          key: 'specValueName',
          scopedSlots: {customRender: 'specValueName'}
        }, {
          title: this.$t('商品.规格.是否可见'),
          dataIndex: 'isVisible',
          key: 'isVisible',
          scopedSlots: {customRender: 'isValueVisible'}
        }, {
          title: this.$t('商品.规格.规格图片'),
          dataIndex: 'picture',
          key: 'picture',
          scopedSlots: {customRender: 'valuePicture'}
        }, {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'}
        }
      ],
      // SKU列定义(移除价格和库存)
      skuColumns: [
        {
          title: this.$t('商品.sku.名称'),
          dataIndex: 'skuName',
          key: 'skuName',
        },
        // {
        //   title: this.$t('商品.sku.编码'),
        //   dataIndex: 'skuCode',
        //   key: 'skuCode',
        //   scopedSlots: {customRender: 'skuCode'}
        // },
        {
          title: '商品条码',
          dataIndex: 'barcode',
          key: 'barcode',
          scopedSlots: {customRender: 'barcode'}
        },
        {
          title: this.$t('重量(g)'),
          dataIndex: 'weight',
          key: 'weight',
          scopedSlots: {customRender: 'skuWeight'}
        }, {
          title: this.$t('商品.sku.图片'),
          dataIndex: 'picture',
          key: 'picture',
          scopedSlots: {customRender: 'skuPicture'}
        }
      ],
      specDisable: false,
      shopId: null,
      form: {
        goodsName: undefined,
        goodsType: 1,
        unit: undefined,
        picture: undefined,
        color: undefined,
        imgList: [],
        categoryId: undefined,
        crossCategoryId: undefined,
        shopId: undefined,
        shopCategoryId: undefined,
        brandId: undefined,
        minBuyNum: undefined,
        maxBuyNum: undefined,
        saleStartTime: undefined,
        saleEndTime: undefined,
        price: undefined,
        marketPrice: undefined,
        costPrice: undefined,
        virtualSalesNum: undefined,
        memberPrice: undefined,
        seckillPrice: undefined,
        activityPrice: undefined,
        groupPrice: undefined,
        vipPrice: undefined,
        weight: undefined,
        barcode: undefined,
        isMultipleSpec: false,
        isAllowMerge: undefined,
        freightTemplateId: undefined,
        stock: undefined,
        description: undefined,
        isRecommend: false,
        isNew: undefined,
        isWell: undefined,
        isShowCalendar: undefined,
        isShowSalesNum: undefined,
        status: 0,
        sort: undefined,
        refundTypeList: [],
        labelList: [],
        prodAreaList: [],
        specList: [],
        skuList: [],
        localeList: [],
        remark: undefined,
        packageId: undefined,
        video: undefined,
        country: undefined,
        sellShopIdList: [],
        isMaxBuy: false
      },
      rules: {
        goodsName: [
          {required: true, message: this.$t('商品.商品名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ],
        goodsType: [
          {required: true, message: this.$t('商品.商品类型') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        picture: [
          {required: true, message: this.$t('商品.商品主图') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        isMultipleSpec: [
          {required: true, message: this.$t('商品.是否多规格') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        status: [
          {required: true, message: this.$t('商品.商品状态') + this.$t('通用.文本.不能为空'), trigger: 'change'}
        ],
        specName: [
          {required: true, message: this.$t('商品.规格.规格名称') + this.$t('通用.文本.不能为空'), trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    // 打开抽屉
    open() {
      this.visible = true
      this.shopId = storage.get(SHOP_ID)
      console.log('InitDrawer open, shopId:', this.shopId)
      this.loading = true
      this.resetForm()
      this.loadData()
    },
    // 加载数据
    loadData() {
      Promise.all([
        this.getCategoryList(),
        this.getCategoryListShop(),
        this.getCrossCategoryList(),
        this.getBrandList()
      ]).finally(() => {
        this.loading = false
      })
    },
    // 重置表单
    resetForm() {
      this.form = {
        goodsName: undefined,
        goodsType: 1,
        unit: undefined,
        picture: undefined,
        color: undefined,
        imgList: [],
        categoryId: undefined,
        crossCategoryId: undefined,
        shopId: undefined,
        shopCategoryId: undefined,
        brandId: undefined,
        minBuyNum: undefined,
        maxBuyNum: undefined,
        saleStartTime: undefined,
        saleEndTime: undefined,
        price: undefined,
        marketPrice: undefined,
        costPrice: undefined,
        virtualSalesNum: undefined,
        memberPrice: undefined,
        seckillPrice: undefined,
        activityPrice: undefined,
        groupPrice: undefined,
        vipPrice: undefined,
        weight: undefined,
        barcode: undefined,
        isMultipleSpec: false,
        isAllowMerge: undefined,
        freightTemplateId: undefined,
        stock: undefined,
        description: undefined,
        isRecommend: false,
        isNew: undefined,
        isWell: undefined,
        isShowCalendar: undefined,
        isShowSalesNum: undefined,
        status: 0,
        sort: undefined,
        refundTypeList: [],
        labelList: [],
        prodAreaList: [],
        specList: [],
        skuList: [],
        localeList: [],
        remark: undefined,
        packageId: undefined,
        video: undefined,
        country: undefined,
        sellShopIdList: [],
        isMaxBuy: false
      }
      this.categorySelected = []
      this.specDisable = false
    },
    getCategoryList() {
      return listCategoryPlat().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.categoryListPlat = children
      }).catch(error => {
        console.error('获取平台分类失败:', error)
        this.$message.error('获取平台分类失败')
      })
    },
    getCategoryListShop() {
      return listCategoryShop().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.categoryListShop = children
      }).catch(error => {
        console.error('获取店铺分类失败:', error)
        this.$message.error('获取店铺分类失败')
      })
    },
    getCrossCategoryList() {
      return listCategoryPlat().then(response => {
        let children = this.handleTree(response.data, 'id', 'pid')
        this.crossCategoryList = children
      }).catch(error => {
        console.error('获取跨境分类失败:', error)
        this.$message.error('获取跨境分类失败')
      })
    },
    getBrandList() {
      return allBrand().then(response => {
        this.brandList = response.data;
      }).catch(error => {
        console.error('获取品牌列表失败:', error)
        this.$message.error('获取品牌列表失败')
      })
    },
    handleBrandSearch(value) {
      listBrand({name: value}).then(response => {
        this.brandList = response.data;
      })
    },
    handleBrandChange(value) {
      this.form.brandId = value
    },
    onCategoryChange(value) {
      if (value && value.length > 0) {
        this.form.categoryId = value[value.length - 1]
      } else {
        this.form.categoryId = undefined
      }
    },
    onCategoryChangeShop(value) {
      this.form.shopCategoryId = value
    },
    onCrossCategoryChange(value) {
      if (value && value.length > 0) {
        this.form.crossCategoryId = value[value.length - 1]
      } else {
        this.form.crossCategoryId = undefined
      }
    },
    onSaleEndChange() {},
    onSaleEndOk() {},
    limitMaxBuyNum() {},
    limitWeight() {},
    onRefundTypeChange() {},
    multipleSpecChange() {},
    addSpec(index) {
      const specListLength = this.form.specList.length + 1;
      const newData = {
        id: specListLength,
        specName: '',
        isHaveImg: false,
        sort: specListLength,
        specValueList: []
      };
      this.form.specList.push(newData);
    },
    editSpec() {
      this.specDisable = false
    },
    delSpec(id) {
      this.form.specList.splice(id, 1)
    },
    addSpecValue(item) {
      let index = item.id % 10000 * 100 + item.specValueList.length + 1;
      const newData = {
        index: index,
        id: index,
        specValueName: '',
        specName: item.specName,
        picture: '',
        isVisible: true,
        sort: 0,
      };
      item.specValueList.push(newData);
    },
    delSpecValue(item, record) {
      item.specValueList = item.specValueList.filter(e => e.id !== record.id);
    },
    validatorSpecValue(item) {
      const specValueNames = item.specValueList.map(v => v.specValueName)
      const duplicates = specValueNames.filter((item, index) => specValueNames.indexOf(item) !== index)
      if (duplicates.length > 0) {
        item.specErrorMessage = '规格值不能重复'
      } else {
        item.specErrorMessage = undefined
      }
    },
    isSpecPicChange() {
      this.isSpecPic = this.form.specList.some(item => item.isHaveImg === true)
    },
    generateSkus() {
      this.specDisable = true
      this.skuLoading = true

      this.form.skuList = []
      let skuValueList = []
      //拿到所有的sku值
      this.form.specList.forEach(spec => {
        skuValueList.push(spec.specValueList)
      })
      //递归,求笛卡尔积
      let sku = this.cartesianProduct(skuValueList)
      //把这些sku 组装一下放到skuList里
      let skuList = []
      let index = 1
      sku.forEach(e => {
        let name = ''
        let skuPic = ''
        let specValueIds = ''
        e.forEach(j => {
          name += j.specValueName + "  "
          specValueIds += j.id + ":"
          if (j.picture) {
            skuPic = j.picture
          }
        })
        specValueIds = specValueIds.substring(0, specValueIds.length - 1)
        const newData = {
          id: index,
          skuName: name,
          skuCode: null,
          barcode: null,
          price: 0,
          memberPrice: 0,
          groupPrice: 0,
          activityPrice: 0,
          seckillPrice: 0,
          picture: skuPic,
          specValueIds: specValueIds,
          stock: 0,
          weight: 0,
        }
        skuList.push(newData)
        index++
      })
      this.form.skuList = skuList
      this.skuLoading = false
      console.log('sku', this.form.skuList)
    },
    validatorSku() {},

    cartesianProduct(arr) {
      if (arr.length === 0) {
        return [[]]
      }
      if (arr.length === 1) {
        return arr[0].map(item => [item])
      }
      const result = []
      const rest = this.cartesianProduct(arr.slice(1))
      for (const item of arr[0]) {
        for (const r of rest) {
          result.push([item, ...r])
        }
      }
      return result
    },
    handlePreview(file) {
      this.previewUrl = file.url || file.thumbUrl
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    beforeOssUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPGOrPNG) {
        this.$message.error('只能上传 JPG/PNG 文件')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
      }
      return isJPGOrPNG && isLt2M
    },
    coverSpecValueImgUpload(file, record) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'goods'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          record.picture = res;
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    getLimitOne(index, specValueList) {
      //不可用的list
      let visibleList = specValueList.filter(obj => obj.isVisible === true)
      //可见list里是否有自己
      let selfBoolean = visibleList.filter(obj => obj.index === index).length >= 1
      //如果不可用的小于一个
      let count = visibleList.length
      //如果可用的小于一个,并且自己还是可用的,返回disable
      return selfBoolean && count <= 1
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // 设置默认值
          this.form.imgIdArray = this.form.imgList.join(',')

          // 多规格SKU设置默认值
          if (this.form.isMultipleSpec && this.form.skuList.length > 0) {
            this.form.skuList.forEach(sku => {
              sku.price = 0
              sku.memberPrice = 0
              sku.seckillPrice = 0
              sku.activityPrice = 0
              sku.groupPrice = 0
              sku.vipPrice = 0
              sku.stock = 0
              sku.weight = sku.weight || 0
            })
          } else if (!this.form.isMultipleSpec) {
            // 单规格设置默认值
            this.form.price = 0
            this.form.stock = 0
            this.form.weight = this.form.weight || 0
            this.form.memberPrice = 0
            this.form.seckillPrice = 0
            this.form.activityPrice = 0
            this.form.groupPrice = 0
            this.form.vipPrice = 0
          }

          addGoods(this.form).then(response => {
            this.$message.success('商品初始化成功')
            this.submitLoading = false
            this.handleClose()
            this.$emit('refresh')
          }).catch(error => {
            this.submitLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.loading = false
      this.resetForm()
    },
    handleClose() {
      this.visible = false
      this.loading = false
      this.resetForm()
    },
    // 树形数据处理
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      }
      var childrenListMap = {}
      var nodeIds = {}
      var tree = []
      for (let d of data) {
        let parentId = d[config.parentId]
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = []
        }
        nodeIds[d[config.id]] = d
        childrenListMap[parentId].push(d)
      }
      for (let d of data) {
        let parentId = d[config.parentId]
        if (nodeIds[parentId] == null) {
          tree.push(d)
        }
      }
      for (let t of tree) {
        adaptToChildrenList(t)
      }
      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]]
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c)
          }
        }
      }
      return tree
    }
  }
}
</script>

<style scoped>
.box {
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
}
.delSpec {
  position: absolute;
  right: -10px;
  top: -10px;
  font-size: 20px;
  color: #ff4d4f;
  cursor: pointer;
  z-index: 10;
}
.margin-bottom {
  margin-bottom: 10px;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-tb {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
